export const authButton = 'Ingresar';
export const scanButton = 'Escanear cupón';
export const giveStamps = 'Marcar una tarjeta';
